import React from 'react'

const NoContentPage = () => {
    return  (
        <div className="flex flex-col items-center justify-center h-screen bg-cover bg-center bg-gradient-to-r from-purple-500 via-pink-500 to-red-500">
          <img
            src="/OHC-Logo.png" // Replace with your image path
            alt="404 Error"
            className="w-32 h-32 mb-8"
            sizes='10px'
          />
          <div className="text-center text-white">
            <h1 className="text-5xl font-bold text-red-500 mb-4">Oops! Page Not Found</h1>
            <p className="text-lg text-red-500 mb-8">
              The page you're looking for doesn't exist or has been moved.
            </p>
          </div>
        </div>
      );
}

export default NoContentPage